export default __webpack_public_path__ + "static/media/hamburger_menu.16f49ec3.svg";